<div class="container">
    <h1 class="principal-title">Actualidad</h1>
    <br>
    <ng-container *ngIf="newsFlag===1">
        <div class="row">
            <div class="col-sm-12" *ngIf="n">
                <h1 id="br-title" class="news-title">{{ n.title }}</h1>
            </div>
        </div>
    </ng-container>

    <div class="row mb-3">
        <ng-container *ngIf="newsFlag!==1">
            <div class="col-sm-1"></div>
        </ng-container>
        <ng-container *ngIf="n">
            <div class="mb-3" [class]="newsFlag===1 ? 'col-md-9 col-sm-12':'col-md-10 col-sm-12'">
                <ng-container *ngIf="newsFlag===0">
                    <h1 id="br-title" class="news-title">{{ n.title }}</h1>
                </ng-container>
                <ng-container *ngIf="n.img.substr(1,6)==='upload'">
                    <img class="img-fluid img-new img-new-h" src="{{URL}}{{n.img}}" alt="{{n.title}}">
                </ng-container>
                <ng-container *ngIf="n.img.substr(1,6)!=='upload'">
                    <img class="img-fluid img-new img-new-h" src="{{n.img}}" alt="{{n.title}}">
                </ng-container>
                <div class="row">
                    <div class="news-date col-6">{{ n.date | date:'dd/MM/yy' }}</div>
                    <div class="news-autor col-6">{{ n.autor }}</div>
                </div>

                <div *ngFor="let o of cn">
                    <div class="news-content" *ngIf="n.id == +o.idnews" [innerHTML]="o.content"></div>
                </div>
                <div class="text-end">
                    <a class="underline" href="{{n.source}}" target="_blank">Ir a la noticia original</a>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="newsFlag===0">
            <div class="col-sm-1"></div>
        </ng-container>
        <!-- Inicia sección noticias similares -->
        <ng-container *ngIf="newsFlag===1">
            <div class="col-md-3 col-sm-12 mt-1">
                <div class="title-related-news">Noticias relacionadas</div>
                <ng-container *ngFor="let new of news; let i=index ">
                    <ng-container *ngIf="i>0">
                        <div class="card mb-3 mt-2" style="width: auto;">
                            <ng-container *ngIf="new.img.substr(1,6)==='upload'">
                                <img class="card-img-top" style="object-fit: cover;" src="{{URL}}{{new.img}}"
                                    alt="image">
                            </ng-container>
                            <ng-container *ngIf="new.img.substr(1,6)!=='upload'">
                                <img class="card-img-top" style="object-fit: cover;" src="{{new.img}}" alt="image">
                            </ng-container>
                            <div class="card-body">
                                <a class="underline related-new-title" routerLink="../{{new.id}}"
                                    (click)="changeNew(new.id)">
                                    {{new.title}}
                                </a>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
        <!-- Términa sección noticias similares -->
        <br>
    </div>
    <hr>
    <h2 class="news-title">Más noticias</h2>
    <div *ngFor="let o of ns|paginate:{itemsPerPage:10, currentPage:pages}; let i = index" class="mb-3">
        <div class="row row-other-news" routerLink="../{{o.id}}" (click)="changeNew(o.id)">
            <div class="col-sm-2 col-5">
                <ng-container *ngIf="o.img.substr(1,6)==='upload'">
                    <img class="img-fluid img-other" src="{{URL}}{{ o.img }}" alt="">
                </ng-container>
                <ng-container *ngIf="o.img.substr(1,6)!=='upload'">
                    <img class="img-fluid img-other" src="{{ o.img }}" alt="">
                </ng-container>
            </div>
            <div class="col-sm-10 col-7">
                <a class="underline other-news-title" routerLink="../{{o.id}}" (click)="changeNew(o.id)">{{ o.title
                    }}</a>
                <div class="d-none d-sm-block">
                    <div class="news-content-mini">{{ limitWords(o.content) }}</div>
                </div>
                <div class="news-date">{{ o.date | date:'dd/MM/yy' }}</div>
            </div>
            <br>
        </div>
        <br>
    </div>
    <pagination-controls (pageChange)="pages = $event" previousLabel="Anterior" nextLabel="Siguiente">
    </pagination-controls>
</div>